import React from 'react'
import DeliveryOptionText from "./DeliveryOption";
import {connect} from "react-redux";

export const getOptionText = (deliveryOption:any)=>{
    return <DeliveryOptionTextContainer deliveryOption={deliveryOption}></DeliveryOptionTextContainer>
};

const mapStateToProps = ({globalReducer}: any) => {
    return {
        defaultLanguage: globalReducer.styles.CommonSettings.DefaultLanguage,
        currentLanguage: globalReducer.currentLanguage
    }
};

export const DeliveryOptionTextContainer = connect<any, any, any>(
    mapStateToProps,
    null
)(DeliveryOptionText);